export default "﻿<div>\n    <h2>\n        Zal Eve Home\n    </h2>\n    \n</div>\n"